module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1.4rem"
    },
    attrs: {
      "for": "itemGroups"
    }
  }, [_vm._v("Item Category")]), _vm._v(" "), _c('Dropdown', {
    staticClass: "dropdown-custom",
    attrs: {
      "options": _vm.itemGroups,
      "optionLabel": "name",
      "placeholder": "Select Category"
    },
    on: {
      "change": _vm.filterItemsByGroup
    },
    model: {
      value: (_vm.selectedGroup),
      callback: function($$v) {
        _vm.selectedGroup = $$v
      },
      expression: "selectedGroup"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1.4rem"
    },
    attrs: {
      "for": "items"
    }
  }, [_vm._v("Items")]), _vm._v(" "), _c('MultiSelect', {
    staticClass: "multiselect-custom",
    attrs: {
      "options": _vm.filteredItems,
      "optionLabel": "name",
      "placeholder": "Select Items",
      "showCheckbox": true,
      "filter": true
    },
    on: {
      "filter": _vm.searchItems
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(slotProps) {
        return [_c('div', {
          staticClass: "p-multiselect-item-option"
        }, [_c('span', [_vm._v(_vm._s(slotProps.option.name))])])]
      }
    }]),
    model: {
      value: (_vm.selectedItems),
      callback: function($$v) {
        _vm.selectedItems = $$v
      },
      expression: "selectedItems"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": "Generate Report",
      "icon": "pi pi-search"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchMultiItemProfitData.apply(null, arguments)
      }
    }
  })], 1)])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticClass: "p-grid"
  }, [_c('div', {
    staticClass: "p-col-12 p-lg-6 chart-wrapper"
  }, [_c('h4', [_vm._v("Profit/Loss Analysis (Bar)")]), _vm._v(" "), _c('div', {
    staticClass: "chart-subcontainer"
  }, [_c('canvas', {
    attrs: {
      "id": "profit-bar-chart"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p-col-12 p-lg-6 chart-wrapper"
  }, [_c('h4', [_vm._v("Profit/Loss Trends (Line)")]), _vm._v(" "), _c('div', {
    staticClass: "chart-subcontainer"
  }, [_c('canvas', {
    attrs: {
      "id": "profit-line-chart"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e4365e7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/graphReport/ItemWiseProfitLossAnalysisGraph.vue
// module id = 2260
// module chunks = 0